
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.73 12.953c1.766-2.335 3.603-4.766 3.603-6.953A5.333 5.333 0 002.667 6c0 2.187 1.837 4.618 3.602 6.953.613.81 1.216 1.608 1.731 2.38.515-.772 1.119-1.57 1.73-2.38zM8 8a2 2 0 100-4 2 2 0 000 4z","fill":"#000023"}})])
          )
        }
      }
    